"use client";

import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AIAssistantResponse } from '@/lib/ai-assistant/types';

interface AIResponseModalContextType {
  isModalOpen: boolean;
  currentResponse: AIAssistantResponse | null;
  openModal: (response: AIAssistantResponse) => void;
  closeModal: () => void;
  clearResponse: () => void;
}

const AIResponseModalContext = createContext<AIResponseModalContextType | undefined>(undefined);

interface AIResponseModalProviderProps {
  children: ReactNode;
}

export function AIResponseModalProvider({ children }: AIResponseModalProviderProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentResponse, setCurrentResponse] = useState<AIAssistantResponse | null>(null);

  const openModal = (response: AIAssistantResponse) => {
    console.log('Global context: Opening AI response modal with response:', response);
    setCurrentResponse(response);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    console.log('Global context: Closing AI response modal');
    setIsModalOpen(false);
  };

  const clearResponse = () => {
    setCurrentResponse(null);
  };

  const value: AIResponseModalContextType = {
    isModalOpen,
    currentResponse,
    openModal,
    closeModal,
    clearResponse,
  };

  return (
    <AIResponseModalContext.Provider value={value}>
      {children}
    </AIResponseModalContext.Provider>
  );
}

export function useAIResponseModal() {
  const context = useContext(AIResponseModalContext);
  if (context === undefined) {
    throw new Error('useAIResponseModal must be used within an AIResponseModalProvider');
  }
  return context;
}
